<template>
    <b-container fluid class="mb-5">
        <b-row>
            <b-col cols="10" offset="1">
                <p><router-link to="/">Back to Home</router-link></p>
                <b-img src="/images/interaction-studio/banner.jpg" class="img-fluid mx-auto d-block" style="max-height: 500px"></b-img>

                <h3 class="mt-4 text-center">
                    The Interaction Studio game mode allows you to create your own interactions for FarmD
                </h3>

                <h2 class="mt-4">Introduction</h2>
                <p>
                    Most of the activities you can do in FarmD are "Interactions" - sex positions, kneeling or lying down, sleeping, etc. There are many interactions that are included
                    in the base game, and you can use the Interaction Studio to create your own. You can also copy from other interactions (including the built-in ones) to create
                    your own variations or expand on them. Below are guides detailing the various components of the Interaction Studio and how to use them.
                </p>

                <h3 class="mt-4">Overview</h3>
                <p>
                    FarmD's Interaction System is used to define the animations and character actions for the various activities in the game. Interactions are attached 
                    to Interactable Objects, such as "Bed", "Seat With Half-Wall", or "Feral Partner Rear", which have invisible trigger zones that are positioned in 
                    the world or attached to characters.
                </p>

                <p>
                    Interactions are divided into two types: top-level interactions and nested interactions. Those which are "top-level" are entered from the normal
                    walking state, and those that are "nested" can only be accessed through another interaction, referred to as that interaction's "parent" interaction.
                </p>

                <p>
                    Every interaction has at least one Role, which represents a character that is involved in the interaction, and contains data like its body orientation
                    (anthro / feral / etc) and the position and rotation the character will be placed in when starting the interaction.
                </p>

                <p>
                    The State Machine of an interaction begins when all of its Roles are occupied by characters, and controls the animations that each character will do,
                    along with transitions from one pose (state) to another. Generally, you can think of each State as the looping / idle animations, and in each of those 
                    states the player is presented with action buttons that will trigger transitions to other states.
                </p>

                <p>
                    One key component of animations in FarmD is the Alignment System, which allows you to attach a character's limb to the partner, or align cocks to penetrables
                    to start penetration. For more information, check out the documentation for the Change Alignment animation event in the Animation Editor guide.
                </p>

                <h2 class="mt-4">
                    Guides
                </h2>

                <p><router-link :to="{name: 'interaction-studio-guides', params: {guideName: 'InteractionStudio'}}">Interaction Studio</router-link></p>
                <p><router-link :to="{name: 'interaction-studio-guides', params: {guideName: 'StateMachineEditor'}}">State Machine Editor</router-link></p>
                <p><router-link :to="{name: 'interaction-studio-guides', params: {guideName: 'AnimationEditor'}}">Animation Editor</router-link></p>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
    name: 'InteractionStudio',
}
</script>
